import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';
import { SharedModule } from '../../shared/shared.module';
import { UserManagementRoutingModule } from './user-management.routing';
import { UserManagementComponent } from './pages/user-management/user-management.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    UserManagementRoutingModule,
    SharedModule,
    NgxLoadingModule
  ],
  declarations: [UserManagementComponent]
})
export class UserManagementModule { }
